/**
 * New Gate Pass In. Writes nothing until the guard saves: the number is minted then.
 *
 * The plant is the one picked in the switcher, else the login's only plant. Head office with no
 * plant picked is told to pick one, because a pass number belongs to a plant.
 */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { FormPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { PassInFormPage } from "@/features/gate-pass-in/components/pass-in-form-page";

export const Route = createFileRoute("/_app/gate/pass-in/new")({
  beforeLoad: () => {
    // A new pass lands on Inward Done, so that tab must be open to the login (0076).
    const { can, me } = useAuth.getState();
    if (!can("gate.pass_in") || !me?.gateTabs?.includes("inward_done"))
      throw redirect({ to: "/gate" });
  },
  component: Page,
});

function Page() {
  const { selected, ready } = useFacilities();
  if (!ready) return <FormPageSkeleton />;
  return (
    <PassInFormPage
      pass={null}
      facilityId={selected?.id ?? null}
      plantName={selected ? `${selected.name} (${selected.plantCode})` : null}
    />
  );
}
